document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  document.querySelectorAll('#section-info h1').forEach(function (heading) {
    var replacement = document.createElement('h2');
    Array.from(heading.attributes).forEach(function (attr) {
      replacement.setAttribute(attr.name, attr.value);
    });
    replacement.innerHTML = heading.innerHTML;
    heading.replaceWith(replacement);
  });

  document.querySelectorAll('.f8pr-variant-selection label').forEach(function (label) {
    var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      node.nodeValue = node.nodeValue.replace(/\bColour\b/g, 'Color');
    });
  });
});
